<div class="cloud-cta-banner">
  <div class="cloud-cta-banner__content">
    <div class="container">
      <div class="col-md-6 offset-md-1 text-center text-md-start">
        <h3 class="cloud-cta-banner__text">{{block.data.text}}</h3>
        <ng-container *ngIf="block.data.btnText">
          <a [href]="block.data.buttonLink" [target]="block.data.target" class="cloud-cta-banner__link">
            <button class="cloud-cta-banner__btn-blue">
              {{block.data.btnText}}
            </button>
          </a>
        </ng-container>
      </div>
    </div>
  </div>
</div>
